<template>
    <div>
        <video-background
            :style="{height: height}"
            :src="$api.getImageUrl(src) + '&_ignore=.mp4'"
        />
    </div>
</template>

<script>
import VideoBackground from 'vue-responsive-video-background-player'
export default {
    name: 'zoezi-video',

    zoezi: {
        title: 'Video',
        icon: 'mdi-video',
        internal: true
    },

    components: {
        VideoBackground
    },

    props: {
        src: {
            title: 'Video address',
            type: String,
            fulltype: 'video'
        },
        height: {
            title: 'Height',
            type: String,
            default: '400px'
        }
    }
}
</script>
